import { TMenuItemAny } from '../../api'

export function calculateItemsTotal(items: TMenuItemAny[]) {
  return items
    .map((item) => parseFloat(item.subtotal))
    .reduce((a, b) => a + b, 0)
    .toFixed(2)
}
